/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxtE2eV1TestRunState } from '@interxfi/types';
import { schema } from 'normalizr';

export const IXT_E2E_V1_TEST_RUN_STATE_ENTITY_NAME = 'ixt.e2e.v1.TestRun';
export const ixtE2eV1TestRunStateEntity = new schema.Entity<IxtE2eV1TestRunState>(IXT_E2E_V1_TEST_RUN_STATE_ENTITY_NAME, {}, { idAttribute: (entity: IxtE2eV1TestRunState) => `${entity.testRunId}-${entity.environment}` });

